export interface PriceParams {
  price: number;
  currency: string;
  currencyDisplay?: string;
}
